/* Judge.me review image retry: 2 retries (1.5s, 4s) then hide the broken tile */
// AI Agent làm theo chỉ thị của anh Hoá — 2026-10-16 18:25 VN — WEB-20261016-suzitee-jdgm-img-v1
// Đã làm: chỉ coi ảnh review là lỗi khi có sự kiện "error" THẬT (bỏ quét lúc window.load theo
// complete && !naturalWidth — trên iOS/WebKit ảnh lazy chưa tải bị nhận nhầm là lỗi rồi bị ẩn cứng).
// Bỏ qua error khi src rỗng. Ảnh đã ẩn mà sau đó load được thì hiện lại. Retry đổi src giữ nguyên.
(function () {
  var D = [1500, 4000], S = '.jdgm-rev__pic-img';
  function bust(u, n) { return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'szr=' + n : u; }
  function fail(im) {
    if (!im.matches || !im.matches(S)) return;
    if (!im.getAttribute('src') && !im.getAttribute('srcset')) return;
    var n = +im.getAttribute('data-szr') || 0;
    if (im.__szt) return;
    if (n >= D.length) return hide(im);
    if (!im.__o) im.__o = [im.getAttribute('src'), im.getAttribute('srcset')];
    im.__szt = setTimeout(function () {
      im.__szt = 0;
      im.setAttribute('data-szr', n + 1);
      var o = im.__o;
      if (o[1]) im.setAttribute('srcset', o[1].replace(/(\S+)(\s+\d+(\.\d+)?[wx])?(,|$)/g, function (m, u, d, x, e) { return bust(u, n + 1) + (d || '') + e; }));
      if (o[0]) im.setAttribute('src', bust(o[0], n + 1));
    }, D[n]);
  }
  function off(el) {
    var r = el.getBoundingClientRect();
    if (r.top > window.innerHeight + 50) el.style.setProperty('display', 'none', 'important');
    else el.style.setProperty('visibility', 'hidden', 'important');
  }
  function on(el) { el.style.removeProperty('display'); el.style.removeProperty('visibility'); }
  function hide(im) {
    var t = im.closest('.jdgm-rev__pic-link') || im, box = im.closest('.jdgm-rev__pics');
    off(t);
    im.setAttribute('data-szx', 1);
    if (box) { var v = false, a = box.querySelectorAll(S); for (var i = 0; i < a.length; i++) if (!a[i].hasAttribute('data-szx')) v = true; if (!v) off(box); }
  }
  document.addEventListener('error', function (e) { fail(e.target); }, true);
  document.addEventListener('load', function (e) {
    var im = e.target;
    if (!im.matches || !im.matches(S) || !im.hasAttribute('data-szx') || !im.naturalWidth) return;
    im.removeAttribute('data-szx');
    on(im.closest('.jdgm-rev__pic-link') || im);
    var box = im.closest('.jdgm-rev__pics'); if (box) on(box);
  }, true);
})();
